import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_DEFAULT_BUTTONS, FLAT_DEFAULT_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatDefaultButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={DefaultButton} span={FLAT_DEFAULT_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn color="primary" className="btn-square" id="Tooltip-1">{PrimaryButton}</Btn>
        <ToolTip target="Tooltip-1" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-primary</ToolTip>
        {FLAT_DEFAULT_BUTTONS_LIST.map((data, index) => (
          <CommonFlateButton key={index} item={data} />
        ))}
      </CardBody>
    </Card>
  );
};

export default FlatDefaultButtons;
